// Mock data for Gyanodeepti School & Day Care website
// This file contains all static content and will be replaced with backend integration later

export const schoolInfo = {
  name: "Gyanodeepti School & Day Care",
  tagline: "Nurturing Young Minds with Care and Excellence",
  phone: "+91 92156 33563",
  whatsapp: "+91 92156 33563",
  email: "gyanodeeptischool@gmail.com",
  address: "Sector 8, Parker White Lily, Sonipat, Haryana, India",
  mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3491.234567890123!2d77.0195!3d28.9942!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjjCsDU5JzM5LjEiTiA3N8KwMDEnMTAuMiJF!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin"
};

export const programs = [
  {
    id: 1,
    title: "Play Group",
    ageGroup: "2–3 Years",
    description: "Introduction to school environment through play-based learning, sensory activities, and social interaction in a safe, nurturing space.",
    icon: "Baby"
  },
  {
    id: 2,
    title: "PP1 / Nursery / Pre-Nursery",
    ageGroup: "3+ Years",
    description: "Foundation building through stories, rhymes, creative arts, and hands-on activities that develop cognitive and motor skills.",
    icon: "Palette"
  },
  {
    id: 3,
    title: "PP2 / LKG / Nursery",
    ageGroup: "4+ Years",
    description: "Pre-primary education focusing on language development, number concepts, environmental awareness, and school readiness.",
    icon: "BookOpen"
  },
  {
    id: 4,
    title: "PP3 / UKG / KG",
    ageGroup: "5+ Years",
    description: "Advanced kindergarten curriculum preparing children for formal schooling with enhanced literacy, numeracy, and social skills.",
    icon: "GraduationCap"
  }
];

export const features = [
  {
    id: 1,
    title: "Activity-Based Learning",
    description: "Hands-on learning experiences that make education fun and engaging",
    icon: "Lightbulb"
  },
  {
    id: 2,
    title: "Experienced Teachers",
    description: "Qualified and caring educators dedicated to your child's growth",
    icon: "Users"
  },
  {
    id: 3,
    title: "Safe & Hygienic Campus",
    description: "Clean, secure environment with CCTV monitoring and safety protocols",
    icon: "Shield"
  },
  {
    id: 4,
    title: "Modern Teaching Methods",
    description: "Interactive smart classes and innovative teaching techniques",
    icon: "Monitor"
  },
  {
    id: 5,
    title: "Small Class Size",
    description: "Individual attention with optimal student-teacher ratio",
    icon: "UserCheck"
  }
];

// REAL SCHOOL IMAGES - Using local images from /public folder
export const images = {
  logo: "/ChatGPT Image Apr 17, 2026, 11_47_20 AM.png",
  hero: "/WhatsApp Image 2026-04-15 at 1.38.52 PM.jpeg",
  topCollage: [
    "/WhatsApp Image 2026-04-15 at 1.38.56 PM.jpeg",
    "/WhatsApp Image 2026-04-15 at 1.39.02 PM.jpeg",
    "/WhatsApp Image 2026-04-15 at 1.39.45 PM.jpeg"
  ],
  gallery: [
    "/WhatsApp Image 2026-04-15 at 1.39.48 PM.jpeg",
    "/WhatsApp Image 2026-04-15 at 1.39.52 PM.jpeg",
    "/WhatsApp Image 2026-04-15 at 1.39.53 PM.jpeg",
    "/WhatsApp Image 2026-04-15 at 1.39.54 PM.jpeg",
    "/WhatsApp Image 2026-04-15 at 1.39.55 PM.jpeg",
    "/WhatsApp Image 2026-04-15 at 1.39.56 PM.jpeg",
    "/WhatsApp Image 2026-04-15 at 1.40.00 PM.jpeg"
  ]
};

export const whatsappMessage = "Hi, I want to inquire about admissions at Gyanodeepti School & Day Care";

export const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    role: "Parent of Aarav (LKG)",
    image: null,
    rating: 5,
    text: "Gyanodeepti has been a blessing for our family. The teachers are so caring and the environment is perfect for young children. My son loves going to school every day!"
  },
  {
    id: 2,
    name: "Rajesh Kumar",
    role: "Parent of Ananya (Class 2)",
    image: null,
    rating: 5,
    text: "The individual attention and activity-based learning approach has really helped my daughter excel. The safety measures and hygiene standards are excellent."
  },
  {
    id: 3,
    name: "Neha Verma",
    role: "Parent of Ishaan (Nursery)",
    image: null,
    rating: 5,
    text: "As a working mother, I was worried about finding the right school. Gyanodeepti exceeded all my expectations. The staff is wonderful and my child is thriving here!"
  }
];

export const trustStats = [
  { icon: "Award", number: "15+", label: "Years Experience" },
  { icon: "Users", number: "50+", label: "Happy Students" },
  { icon: "Shield", number: "100%", label: "Safe Campus" },
  { icon: "GraduationCap", number: "25+", label: "Expert Teachers" }
];
